import { render, staticRenderFns } from "./ShortcutsIcon.vue?vue&type=template&id=39315a81"
import script from "./ShortcutsIcon.vue?vue&type=script&lang=js"
export * from "./ShortcutsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports